import { DataGridProps, GridColDef } from '@mui/x-data-grid';
import { camelCase, isArray, isPlainObject } from 'lodash';

const getDecodedToken = (token: string) => {
  try {
    if (!token || !(token.split('.').length === 3)) {
      return false;
    }
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace('-', '+').replace('_', '/');
    const decodedToken = JSON.parse(atob(base64));
    if (decodedToken) {
      return decodedToken;
    }
    return false;
  } catch (error) {
    return false;
  }
};
export const checkTokenExp = (token: string) => {
  const decodedToken = getDecodedToken(token);
  if (decodedToken && decodedToken.exp) {
    return decodedToken.exp > new Date().valueOf() / 1000;
  }
  return true;
};
export const getTokenExp = (token: string) => {
  const decodedToken = getDecodedToken(token);
  if (decodedToken && decodedToken.exp) {
    return decodedToken.exp;
  }
  return null;
};

/**
 * 递归遍历
 * @param value
 * @param map 执行函数
 * @returns
 */
const deepMapKeys = <T>(value: T, map: (key: string) => string): T => {
  if (isPlainObject(value)) {
    const obj = value as Record<string, unknown>;

    const newObj: Record<string, unknown> = {};

    for (const [key, val] of Object.entries(obj)) {
      newObj[map(key)] = deepMapKeys(val, map);
    }

    return newObj as T;
  } else if (isArray(value)) {
    const array = value as unknown[];

    return array.map((val: unknown) => deepMapKeys(val, map)) as T;
  } else {
    return value;
  }
};
/**
 * 转化为小驼峰
 * @param value
 * @returns
 */
export const toCamelCase = <T>(value: T): T => {
  return deepMapKeys(value, (key: string) => camelCase(key));
};

export const generateDefaultDataGridProps = (params: DataGridProps) => {
  const defaultColumnConfig: Partial<GridColDef> = {
    align: 'center',
    headerAlign: 'center',
    sortable: false,
  };
  const { columns, paginationModel, pageSizeOptions, ...othter } = params;
  const initColumns = columns.map((item) => ({ ...defaultColumnConfig, ...item }));
  const dataGridProp: DataGridProps = {
    disableColumnFilter: true,
    disableColumnMenu: true,
    disableColumnResize: true,
    disableColumnSorting: true,
    hideFooterSelectedRowCount: true,
    columns: initColumns,
    ...othter,
  };
  return dataGridProp;
};
